module.exports = __webpack_public_path__ + "static/hero-laptops-3c231f681ed97bbd33863500dc9cc7dd.jpg";